@if (!acting() && !minTimeout()) {
  <span class="fake-link" (click)="act()">
  <ng-content />
</span>
} @else {
  <app-loading [inline]="true" />
}
